import { LinkCard, LinkCardBody, useExpandableItems } from '../../../common';
import styles from './company-detail-interviews.component.module.scss';
import { SectionLayout } from './section-layout.component';

type InterviewType = {
  id: number;
  alias: string;
  title?: string | null;
  publishedAt?: string | null;
  thumbnailUrl?: string | null;
};

const InterviewItem = ({ interview }: { interview: InterviewType }) => {
  const imageUrl =
    interview.thumbnailUrl ||
    (process.env.NEXT_PUBLIC_YUFFIE_ENV === 'production'
      ? `https://s3-ap-northeast-1.amazonaws.com/findy-code-images/interviews/${interview.alias}/top.jpg`
      : '/images/lp/findy-share-interview.png');

  return (
    <LinkCard
      body={
        <LinkCardBody
          publishedAt={interview.publishedAt}
          title={interview.title}
        />
      }
      href={`/pick-up/interviews/${interview.alias}`}
      thumbnailImage={
        interview.alias && (
          // eslint-disable-next-line @next/next/no-img-element
          <img
            alt={`${interview.title}のサムネイル`}
            className={styles.interviewThumb}
            height={interview.thumbnailUrl ? undefined : 274}
            src={imageUrl}
            width={interview.thumbnailUrl ? undefined : 458}
          />
        )
      }
    />
  );
};

type Props = {
  interviews: InterviewType[];
};

export const CompanyDetailInterviews = ({ interviews }: Props) => {
  const { displayItems, ExpandButton } = useExpandableItems(
    interviews,
    2,
    'インタビューをもっとみる'
  );
  return (
    <SectionLayout heading={{ title: 'インタビュー' }} id="interview">
      <div className={styles.interviewsBlock}>
        {displayItems.map((interview) => (
          <InterviewItem interview={interview} key={interview.alias} />
        ))}
      </div>
      <ExpandButton />
    </SectionLayout>
  );
};
